import { render, staticRenderFns } from "./MakeSureYouUnderstand.vue?vue&type=template&id=7b885b9c&"
import script from "./MakeSureYouUnderstand.vue?vue&type=script&lang=js&"
export * from "./MakeSureYouUnderstand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports